/**
 * users
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 999.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */



export type FeaturesEnum = 'experiments' | 'queues' | 'pipelines' | 'reports';

export const FeaturesEnum = {
    Experiments: 'experiments' as FeaturesEnum,
    Queues: 'queues' as FeaturesEnum,
  Pipelines: 'pipelines' as FeaturesEnum,
  Reports: 'reports' as FeaturesEnum
};
